import * as yup from "yup";
const validations = yup.object().shape({
  name: yup.string().required("validationMessages.required"),
  category: yup.string().required("validationMessages.required"),
  sale_area: yup.string().required("validationMessages.required"),
});

export default validations;
